import React from 'react'
import ReactDOM from 'react-dom'
import ExchangeTradedFunds from './ExchangeTradedFunds.jsx'

class ExchangeTradedFundsLandingElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'etf-landing-react-app'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    ReactDOM.render(
      <ExchangeTradedFunds />,
      document.getElementById(reactContainerId)
    )
  }
}

customElements.define(
  'exchange-traded-funds-landing',
  ExchangeTradedFundsLandingElement
)
